// extracted by mini-css-extract-plugin
export default {"wrapper":"department_wrapper__Os9Ne"};